// extracted by mini-css-extract-plugin
export default {"card":"CardPost_card__q4rg3","image":"CardPost_image__Nxuoo","blocText":"CardPost_blocText__Dk6Hg","title":"CardPost_title__WqthK","excerpt":"CardPost_excerpt__+yR6g"};